module.exports = __webpack_public_path__ + "img/kuwait-3.d978fa01.jpg";